export default __webpack_public_path__ + "static/media/wallet-connect-icon.69b7a669.svg";